import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiShield } = FiIcons;

const SocialProofSection = () => {
    useEffect(() => {
    // SEO: Add structured data for this section
    const sectionData = {
      "@context": "https://schema.org", "@type": "WebPageElement", "name": "Social Proof and Credibility",
      "description": "Showcasing our certifications, awards, and compliance badges as proof of our commitment to security.",
      "hasPart": [
        { "@type": "EducationalOccupationalCredential", "name": "ISO 27001" },
        { "@type": "EducationalOccupationalCredential", "name": "SOC 2 Type II" },
        { "@type": "EducationalOccupationalCredential", "name": "GDPR Compliant" }
      ]
    };
    
    const scriptId = 'social-proof-structured-data';
    let script = document.getElementById(scriptId);
    if (!script) {
      script = document.createElement('script');
      script.id = scriptId;
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(sectionData);
  }, []);

  const certifications = ["ISO 27001", "SOC 2 Type II", "GDPR Compliant", "HIPAA Ready", "PCI DSS", "FedRAMP"];
  const partners = ["Microsoft Azure", "AWS Security", "IBM Security", "Cisco Security", "Palo Alto Networks", "CrowdStrike"];

  return (
    <section className="py-20 bg-white" itemScope itemType="https://schema.org/WebPageElement">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }} viewport={{ once: true }} className="text-center mb-16">
          <h2 className="text-4xl font-bold text-slate-900 mb-6" itemProp="headline">Trusted by Industry Leaders</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" itemProp="description">Our certifications and partnerships demonstrate our commitment to the highest security standards.</p>
        </motion.div>

        <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.3 }} viewport={{ once: true }}>
          <h3 className="text-2xl font-bold text-slate-900 text-center mb-8">Security Certifications & Compliance</h3>
          <div className="flex flex-wrap justify-center gap-4">
            {certifications.map((cert, index) => (
              <div key={index} className="bg-gray-50 p-4 rounded-lg text-center border border-gray-200 hover:border-teal-300 transition-colors flex items-center space-x-2">
                <SafeIcon icon={FiShield} className="text-teal-600 text-lg" />
                <span className="font-semibold text-slate-900 text-sm">{cert}</span>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default SocialProofSection;